import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => { setMenuOpen(false); }, [location]);

  const isHome = location.pathname === '/';
  const navClass = `navbar${scrolled || !isHome ? ' navbar--solid' : ''}${menuOpen ? ' navbar--open' : ''}`;
  const currentLang = i18n.language?.startsWith('fr') ? 'fr' : 'en';

  return (
    <header className={navClass}>
      <div className="navbar__inner">
        <Link to="/" className="navbar__logo">
          <img
            src="https://www.image2url.com/r2/default/images/1777128435495-e7e28c36-d73b-4780-afbf-672579576f88.png"
            alt="Marrakech Best Activities"
            className="navbar__logo-img"
          />
        </Link>

        <nav className={`navbar__nav${menuOpen ? ' navbar__nav--open' : ''}`}>
          <Link to="/tours" className="navbar__link">{t('nav.tours')}</Link>
          <Link to="/activities" className="navbar__link">{t('nav.activities')}</Link>
          <Link to="/destinations" className="navbar__link">{t('nav.destinations')}</Link>
          <Link to="/morocco-guide" className="navbar__link">{t('nav.guide')}</Link>
          <Link to="/about" className="navbar__link">{t('nav.about')}</Link>
          <Link to="/contact" className="navbar__link">{t('nav.contact')}</Link>
          <div className="navbar__lang-switch">
            <button
              className={`navbar__lang-btn${currentLang === 'en' ? ' active' : ''}`}
              onClick={() => i18n.changeLanguage('en')}
            >EN</button>
            <span className="navbar__lang-sep">|</span>
            <button
              className={`navbar__lang-btn${currentLang === 'fr' ? ' active' : ''}`}
              onClick={() => i18n.changeLanguage('fr')}
            >FR</button>
          </div>
          <Link to="/book" className="navbar__cta btn btn-primary btn-sm">{t('nav.bookNow')}</Link>
        </nav>

        <button
          className="navbar__burger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span /><span /><span />
        </button>
      </div>
    </header>
  );
}
